import React from "react";

const Paysafe = () => {
  return <div></div>;
};

export default Paysafe;
